import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import RepProfilePageStore from 'stores/RepProfilePageStore';
import RepProfilePageActions from 'actions/RepProfilePageActions';
import {List} from 'immutable';
import moment from 'moment';
import {extent} from 'd3-array';
import TrendChart from 'components/pure/charts/trend/TrendChart';

class RepProfileTrendChartContainer extends React.Component {
  static getStores() {
    return [RepProfilePageStore];
  }

  static getPropsFromStores() {
    const store = RepProfilePageStore.getState();
    return {
      trendData: store.trendData,
      trendDataLoading: store.trendDataLoading,
    };
  }

  tooltipContent = (item, d, index, pins) => {
    if (pins.includes(index) || pins.length === 0) {
      return (
        <div className="saw-chart-tooltip">
          <p>Date: {d.date.format('M/D/YY')}</p>
          <p>Value: {this.props.formatValue(d.value)}</p>
        </div>
      );
    }

    return null;
  };

  render() {
    const {
      percentageBased,
      trendData,
      trendDataLoading,
      chartLabel,
      color,
      max,
      startDate,
      endDate,
    } = this.props;

    const data = trendData
      ? List(
          trendData.data.map(d => ({
            date: moment(d.date),
            value: d.value,
          }))
        )
      : List();

    const trendToDisplay = {
      color: color,
      // preserve these so we can easily get the entire date range
      firstDate: data.size > 0 ? data.first().date : moment().subtract(7, 'days'),
      lastDate: data.size > 0 ? data.last().date : moment(),
      label: chartLabel,
      data: data.filter(d => d.value !== null),
    };

    const yMax = percentageBased ? [max] : data.map(d => d.value);
    const yRange = trendData ? extent([0, ...yMax]) : extent([0, 100]);

    return (
      <TrendChart
        yRange={yRange}
        yLabel={''} // no label, they're all different and context was implied
        margins={{
          top: 10,
          left: 50,
          right: 15,
          bottom: 25,
        }}
        trends={List([trendToDisplay])}
        loading={trendDataLoading}
        onClose={this.props.onClose}
        legend={null}
        tooltipContent={this.tooltipContent}
        label={chartLabel}
        formatValue={this.props.formatValue}
        startDate={startDate}
        endDate={endDate}
      />
    );
  }

  componentWillUnmount() {
    RepProfilePageActions.clearTrendData();
  }
}

export default connectToStores(RepProfileTrendChartContainer);
